import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd, NavigationStart } from '@angular/router';

import { Product } from '../../common/models/product';
import { PaymentStatus } from '../../common/models/paymentStatus';
import { PaymentInformation, OrderInformation } from '../../common/models/paymentInfo';
import { Receipt } from '../../common/models/receipt';
import { Member } from '../../common/models/member';
import { Invoice } from '../../common/models/invoice';
import { PaymentHistoryLog } from '../../common/models/PaymentHistoryLog';

import { LaddaModule } from 'angular2-ladda';
import { PaymentService } from '../services/payment.service';
import { SessionManager } from '../../common/helpers/session-manager';
import { __core_private_testing_placeholder__ } from '@angular/core/testing';
import { AppLoggingService } from '../../common/services/AppLogging.service';
import { InvoiceService } from '../services/invoice.service';
import { ProductService } from '../../shopping-cart/services/product.service';
import {
  paymentProcessingStatus, paymentMethod, responseCode, transactionLogDescription,
  paymentProcessingStatusId
} from '../../common/helpers/string-helper';

@Component({
  selector: 'app-payment-processing',
  templateUrl: './payment-processing.component.html',
  styleUrls: ['./payment-processing.component.css']
})
export class PaymentProcessingComponent implements OnInit {

  member: Member;
  paymentInfoObj: PaymentInformation;
  paymentReceiptInfoObj: PaymentInformation;
  progress: boolean | number = false;
  dateString: string;
  enablePaymentRecipt: boolean;
  messageString: string;
  productNamesString: string;
  promotionProducts: Product[] = [];
  invoiceInfoObj: Invoice;
  productListCode = localStorage.getItem('productListCode');
  paymentHistoryLog = new PaymentHistoryLog();
  sessionId = localStorage.getItem('sessionID');

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private paymentService: PaymentService,
    private sessionManager: SessionManager,
    private log: AppLoggingService,
    private productService: ProductService,
    private invoiceService: InvoiceService) {
    this.enablePaymentRecipt = false;
    this.progress = 0;
    this.member = new Member();
    this.invoiceInfoObj = new Invoice();
  }


  ngOnInit() {
    this.messageString = paymentProcessingStatus.pleaseWait;
    this.enablePaymentRecipt = false;

    const orderDetails = this.sessionManager.getShoppingCartData();
    const customerDetails = this.sessionManager.getCurrentUser();
    const promoCode = this.sessionManager.getPromoCode();

    this.activatedRoute.queryParams.subscribe((params: Params) => {

      // create products name string separated by comma
      if (orderDetails !== undefined) {
        orderDetails.orderitems.forEach(element => {
          if (this.productNamesString === undefined) {
            this.productNamesString = '';
          }
          if (orderDetails.orderitems.length === 1) {
            this.productNamesString = element.product.productName;
            return;
          }
          this.productNamesString += element.product.productName + ', ';
        });
      }

      const paymentStatus = this.sessionManager.getPaymentStatus();
      if (params.responseCode === responseCode.cancel) {

        // order confirmation start
        this.log.AddPaymentTransactionLog(customerDetails.id, params.transactionId, orderDetails.orderId,
          orderDetails.orderTotal, orderDetails.orderTotal, transactionLogDescription.paymentCancelDesc, paymentMethod.creditCard, 8,
          true, customerDetails.email, promoCode).subscribe((response: Response) => {

          });

        const paymentStatusObj = new PaymentStatus();
        paymentStatus.status = '7';

        this.sessionManager.setPaymentStatus(paymentStatusObj);
        this.router.navigate(['order']);

      } else if (paymentStatus.status === paymentProcessingStatusId.authentication) { // authentication status
        this.genaratePaymentReceipt(params.transactionId, params.responseCode, customerDetails, promoCode);

      } else if (paymentStatus.status === paymentProcessingStatusId.capture) { // capture status
        this.postCaptureForPayment(params.transactionId, responseCode.ok, orderDetails, customerDetails, promoCode, this.sessionId);

      } else {
        if (promoCode === 'medlemskap' && paymentStatus.status !== '9') {
          this.router.navigate(['autorenew'], { queryParams: { transactionId: params.transactionId, responseCode: params.responseCode } });
        }
        else {
          this.genaratePaymentReceipt(params.transactionId, params.responseCode, customerDetails, promoCode);
        }
      }
    });
  }


  // tslint:disable-next-line:max-line-length
  executeCustomeActions(promoCode: string, customerId: string, orderDetails: any, transactionId: string, sessionId: string, invoiceNumber: any, customerEmail: string) {
    this.messageString = paymentProcessingStatus.paymentCheck;

    // execute member related custom actions
    // tslint:disable-next-line:max-line-length
    this.paymentService.processOffer(promoCode, customerId, orderDetails, transactionId, sessionId, invoiceNumber, "Velkommen", "Tusen takk", customerEmail)
      .subscribe(response => {

        this.enablePaymentRecipt = true;
        this.paymentReceiptInfoObj = new PaymentInformation();
        this.paymentReceiptInfoObj.OrderInfo = new OrderInformation();
        this.paymentReceiptInfoObj.OrderInfo.Total = orderDetails.orderTotal;
        this.paymentReceiptInfoObj.OrderInfo.OrderNumber = orderDetails.orderId;
        this.dateString = Date.now().toString();

        if (response === true) {
          this.log.errorCode = 'WSSE544';
          this.router.navigate(['alert']);
        } else {
          this.messageString = paymentProcessingStatus.completed;
          this.enablePaymentRecipt = true;
          this.progress = false;
        }

      }, error => {
        this.enablePaymentRecipt = false;
        this.log.errorCode = error.text().replace('"', '').replace('"', '');
        this.router.navigate(['alert']);
      });
  }


  sendWelcomeEmail(customerDetails: any, orderDetails: any, promoCode: string, transactionId: string) {

    const welcomeEmailDetails = {
      customerDetails: customerDetails,
      orderDetails: orderDetails,
      promotionCode: promoCode,
      transactionId: transactionId
    };
    this.paymentService.sendWelcomeEmail(welcomeEmailDetails, this.sessionId).subscribe((response: any) => {
    });
  }


  genaratePaymentReceipt(transactionId: any, responseCode: any, customerDetails: any, promoCode: any) {

    const orderDetails = this.sessionManager.getShoppingCartData();
    this.messageString = paymentProcessingStatus.paymentCheck;
    this.paymentService.postAuthorizationForPayment(transactionId, responseCode, orderDetails.orderId, orderDetails.orderTotal,
      customerDetails.id, customerDetails.email, promoCode, this.sessionId)
      .subscribe(response => {
        this.postCaptureForPayment(transactionId, responseCode, orderDetails, customerDetails, promoCode, this.sessionId);
      }, error => {
        this.log.errorCode = error.text().replace('"', '').replace('"', '');
        this.router.navigate(['alert']);
        this.productService.getProductsByProductCode().subscribe((response: any) => {
        });
      });
  }


  postCaptureForPayment(transactionId: any, responseCode: any, orderDetails: any, customerDetails: any, promoCode: any, sessionId: string) {
    this.messageString = paymentProcessingStatus.paymentCheck;

    // deduct money from the client account
    this.paymentService.capturePayment(transactionId, responseCode, orderDetails.orderId, orderDetails.orderTotal,
      customerDetails.email, promoCode, customerDetails.id, this.sessionId).subscribe(response => {

        this.paymentHistoryLog.promoCode = promoCode;
        this.paymentHistoryLog.paymentMethod = paymentMethod.creditCard;
        this.paymentHistoryLog.transactionId = transactionId;

        // create invoice
        this.invoiceService.createInvoice(customerDetails.id, orderDetails, 1, this.paymentHistoryLog, sessionId, false).subscribe(createInvoiceSuccess => {
          this.invoiceInfoObj.InvoiceID = createInvoiceSuccess.invoiceNumber;

          // update the member related custom actions
          this.executeCustomeActions(promoCode, customerDetails.id, orderDetails, transactionId, sessionId, this.invoiceInfoObj.InvoiceID, customerDetails.email);

          // Update payment transaction log with invoice number
          this.log.UpdatePaymentTransactionLog(customerDetails.id, null, orderDetails.orderId, null, null, null, null, 14,
            true, null, null, createInvoiceSuccess.invoiceNumber).subscribe((response: Response) => { });

        }, error => {

          // Add invoice creation failed using credit card process log
          this.log.AddPaymentTransactionLog(customerDetails.id, transactionId, orderDetails.orderId, orderDetails.orderTotal,
            orderDetails.orderTotal, transactionLogDescription.creditCardPaymentInvoiceCreationFailedDesc, paymentMethod.creditCard,
            16, true, customerDetails.email, promoCode).subscribe((response: Response) => { });

          // execute member related custom actions
          this.executeCustomeActions(promoCode, customerDetails.id, orderDetails, transactionId, sessionId, this.invoiceInfoObj.InvoiceID, customerDetails.email);
        });
      }, error => {

        this.log.errorCode = error.text().replace('"', '').replace('"', '');
        this.router.navigate(['alert']);
        this.productService.getProductsByProductCode().subscribe((response: any) => { });
      });
  }


  postTransactionStatus(transactionId: any, responseCode: any, customerDetails: any, promoCode: string) {
    this.messageString = paymentProcessingStatus.paymentCheck;
    this.paymentService.postTransactionStatus(transactionId, responseCode, customerDetails.id,
      customerDetails.email, promoCode, this.sessionId)
      .subscribe((response: any) => {
        if (response.hasError) {
          const paymentStatus = new PaymentStatus();
          paymentStatus.status = paymentProcessingStatusId.cancel; // cancel status
          this.paymentInfoObj = response;
          this.sessionManager.setPaymentStatus(paymentStatus);

          this.router.navigate(['paymenterrormessage']);
        } else {
          this.messageString = paymentProcessingStatus.completed;
          this.paymentInfoObj = response;
          this.dateString = this.paymentInfoObj.OrderInfo.TimeStamp.slice(0, 10);
          this.enablePaymentRecipt = true;
          this.progress = false;
        }
      });
  }
}





// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/payment-gateway/payment-processing/payment-processing.component.ts